const initialState = {
    isAddingPayment: false,
    paymentData: [],
};

const PaymentReceivingReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_ADD_PAYMENT":
            return { ...state, isAddingPayment: true };
        case "SUCCESS_ADD_PAYMENT":
            return { ...state, paymentData: action.payload, isAddingPayment: false, };
        case "ERROR_ADD_PAYMENT":
            return { ...state, isAddingPayment: false };


        default:
            return state;
    }
};

export default PaymentReceivingReducer;